import { VFC } from 'react';
import classNames from 'classnames';
import './index.scss';

const PosterCover: VFC<{ src: string; className?: string; onCoverLoad?: () => void }> = ({
  src,
  className,
  onCoverLoad,
}) => (
  <div className={classNames('poster-cover', className)}>
    <img
      crossOrigin="anonymous"
      src={src}
      draggable={false}
      onLoad={() => {
        if (onCoverLoad) onCoverLoad();
      }}
    />
  </div>
);

export default PosterCover;
